import { render, staticRenderFns } from "./DrugCheckStatus.vue?vue&type=template&id=4e6bc0e4"
import script from "./DrugCheckStatus.vue?vue&type=script&lang=js"
export * from "./DrugCheckStatus.vue?vue&type=script&lang=js"
import style0 from "./DrugCheckStatus.vue?vue&type=style&index=0&id=4e6bc0e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports